<template>
    <v-row 
        align="center"
        justify="center"                    
    >
        <v-col
            cols="12"                       
        >
            <v-menu               
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"                           
                transition="scale-transistion"
                offset-y
                min-width="290px"                            
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="initialDate.date"
                        :label="label"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        autocomplete="false"
                        :rules="[() => !!initialDate.date || 'This field is required']"
                        :error-messages="errorMessages"
                        required                                                    
                    >
                        
                    </v-text-field>
                </template>
                <v-date-picker
                    ref="picker"
                    v-model="initialDate.date"
                    :active-picker.sync="activePicker"
                    :max="(d => {d.setFullYear(d.getFullYear() + 1); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().substring(0, 10);})(new Date())"    
                    @change="save"
                >                                
                </v-date-picker>                            
            </v-menu>
        </v-col>       
    </v-row>
</template>

<script>
export default {
    props: {
        label: String,
        initialDate: null,
        rules: [],
        errorMessages: String,
    },

    data: function () {
        return {
            date: this.initialDate.date,
            menu: false,
            activePicker: null,
        }        
    },

    watch: {
        menu (val) {
            if(val){
                this.$nextTick(() => {
                    // console.log(this.$refs.picker.activePicker)
                    // this.$refs.picker.activePicker = 'YEAR';
                    this.activePicker = 'YEAR';
                })
            } 
        },

        // initialDate (val) {
        //     this.date = val;
        // }
    },

    methods: {
        save (date) {
            this.$refs.menu.save(date);
            //console.log(this.initialDate);
        }
    }
}
</script>